const answers = {
  flatFee:
    'In full consideration for the Contributions and all services performed and materials delivered' +
    ' hereunder, Owner shall pay to Contributor a fee of $<FEE> (the “Fee”), payable <PAYMENT SCHEDULE>.',

  gratis:
    'Contributor’s Contribution to the Work(s), services performed, and materials delivered' +
    ' hereunder are rendered on a gratis basis, and as such, Owner shall not be responsible for the' +
    ' payment of any fees, royalties, or other sums in connection with the Work(s), this Agreement,' +
    ' and the Contribution and services of Contributor in connection therewith.  The parties' +
    ' acknowledge that Contributor’s involvement in the Work(s) has promotional and marketing' +
    ' value for Contributor.',

  advance:
    'In consideration for the Contributions and all services performed and materials delivered' +
    ' hereunder, Owner shall pay to Contributor a recoupable advance against royalties in the' +
    ' amount of $<FEE> (the “Advance”), payable <PAYMENT SCHEDULE>.',

  royalty:
    'In consideration for the Contributions and all services performed and materials delivered' +
    ' hereunder, Contributor shall receive a royalty in the amount of <PERCENT>% of <DESCRIBE>' +
    ' (the “Royalty”).  Statements as to Royalties payable hereunder shall be sent by Owner to' +
    ' Contributor at Contributor’s email address as within thirty (30) days after the expiration of each' +
    ' <PERIOD> period for the preceding period.  Concurrently with the rendition of each' +
    ' statement, Owner shall pay Contributor all Royalties shown to be due by such statement.',

  audit:
    'Contributor may audit Owner’s books and records pertaining to the payment of' +
    ' Royalties to Contributor hereunder upon reasonable prior notice.',

  payment0:
    'in full within <DAYS0> days following full execution of this Agreement',

  payment1:
    'in full within <DAYS1> days following Contributor’s satisfactory completion and delivery' +
    ' of the services and Contribution rendered hereunder',

  payment2:
    '$<AMOUNT> payable within <AMOUNTDAYS> days following full execution of this Agreement, and' +
    ' the balance, $<BALANCE> payable within <BALANCEDAYS> days following Contributor’s' +
    ' satisfactory completion and delivery of the services and Contribution rendered hereunder',
};

export default (options) => {
  let content = '';
  let payment = '';
  let checked = true;

  /* eslint-disable */
  if (options.payable === true) {
    if (options.flatFee === 1) {
      content = answers.advance + '<SPACE>';
    } else {
      content = answers.flatFee + '<SPACE>';
    }

    if (parseFloat(options.fee) > 0) {
      content = content.replace('<FEE>', parseFloat(options.fee).toFixed(2));
    } else {
      content = content.replace(
        '<FEE>',
        `<i><u>&nbsp;&nbsp;enter a fee&nbsp;&nbsp;</u></i>`
      );
      checked = false;
    }

    if (options.schedule === 0) {
      payment = answers.payment0;

      if (parseInt(options.scheduleDays0) > 0) {
        payment = payment.replace('<DAYS0>', parseInt(options.scheduleDays0));
      } else {
        payment = payment.replace(
          '<DAYS0>',
          `<i><u>&nbsp;&nbsp;enter days&nbsp;&nbsp;</u></i>`
        );
        checked = false;
      }
    } else if (options.schedule === 1) {
      payment = answers.payment1;

      if (parseInt(options.scheduleDays1) > 0) {
        payment = payment.replace('<DAYS1>', parseInt(options.scheduleDays1));
      } else {
        payment = payment.replace(
          '<DAYS1>',
          `<i><u>&nbsp;&nbsp;enter days&nbsp;&nbsp;</u></i>`
        );
        checked = false;
      }
    } else if (options.schedule === 2) {
      payment = answers.payment2;

      if (parseFloat(options.scheduleAmount) > 0) {
        payment = payment.replace(
          '<AMOUNT>',
          parseFloat(options.scheduleAmount).toFixed(2)
        );
      } else {
        payment = payment.replace(
          '<AMOUNT>',
          `<i><u>&nbsp;&nbsp;enter amount&nbsp;&nbsp;</u></i>`
        );
        checked = false;
      }

      if (parseInt(options.scheduleAmountDays) > 0) {
        payment = payment.replace(
          '<AMOUNTDAYS>',
          parseInt(options.scheduleAmountDays)
        );
      } else {
        payment = payment.replace(
          '<AMOUNTDAYS>',
          `<i><u>&nbsp;&nbsp;enter days&nbsp;&nbsp;</u></i>`
        );
        checked = false;
      }

      if (parseFloat(options.scheduleBalance) > 0) {
        payment = payment.replace(
          '<BALANCE>',
          parseFloat(options.scheduleBalance).toFixed(2)
        );
      } else {
        payment = payment.replace(
          '<BALANCE>',
          `<i><u>&nbsp;&nbsp;enter balance&nbsp;&nbsp;</u></i>`
        );
        checked = false;
      }

      if (parseInt(options.scheduleBalanceDays) > 0) {
        payment = payment.replace(
          '<BALANCEDAYS>',
          parseInt(options.scheduleBalanceDays)
        );
      } else {
        payment = payment.replace(
          '<BALANCEDAYS>',
          `<i><u>&nbsp;&nbsp;enter days&nbsp;&nbsp;</u></i>`
        );
        checked = false;
      }
    }

    if (payment !== '') {
      content = content.replace('<PAYMENT SCHEDULE>', payment);
    } else {
      content = content.replace(
        '<PAYMENT SCHEDULE>',
        `<i><u>&nbsp;&nbsp;payment schedule&nbsp;&nbsp;</u></i>`
      );
      checked = false;
    }
  }

  if (options.royalty === true) {
    content += answers.royalty + '<SPACE>';

    if (options.audit === 'will') {
      content += answers.audit + '<SPACE>';
    } else if (!options.audit) {
      checked = false;
    }

    if (parseInt(options.percent) > 0) {
      content = content.replace('<PERCENT>', parseInt(options.percent));
    } else {
      content = content.replace(
        '<PERCENT>',
        `<i><u>&nbsp;&nbsp;enter a percentage&nbsp;&nbsp;</u></i>`
      );
      checked = false;
    }

    if (options.describe) {
      content = content.replace('<DESCRIBE>', options.describe);
    } else {
      content = content.replace(
        '<DESCRIBE>',
        `<i><u>&nbsp;&nbsp;what revenue stream will this royalty come from?&nbsp;&nbsp;</u></i>`
      );
      checked = false;
    }

    if (options.period) {
      content = content.replace('<PERIOD>', options.period);
    } else {
      content = content.replace(
        '<PERIOD>',
        `<i><u>&nbsp;&nbsp;select&nbsp;&nbsp;</u></i>`
      );
      checked = false;
    }
  }

  if (options.gratis === true) {
    content = answers.gratis + '<SPACE>';
  }

  content = content.substring(0, content.length - 7);
  content = content.replace(new RegExp('<SPACE>', 'g'), ' ');
  checked = content !== '' && checked;
  /* eslint-enable */

  return {
    content,
    checked,
  };
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/Consideration.js